<template>
  <Slider
    v-if="showSlider"
    ref="Slider"
    direction="horizontal"
    :mousewheel-control="true"
    :performance-mode="true"
    :pagination-visible="true"
    :pagination-clickable="true"
    :loop="true"
    @slide-change-start="onSlideChangeStart"
    @slide-change-end="onSlideChangeEnd"
    class="loaderBackground"
    :speed="500"
    :interval="intervalSlider"
    :auto="autoSlider"
  >
    <div v-for="x in homepage.slides" :key="x" v-html="x"></div>
  </Slider>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Slider from "vue-plain-slider";
const fetchInitialData = (store, route) => {
  return store.dispatch(`page/getHomepage`);
};
export default {
  components: { Slider },
  data() {
    return {
      showSlider: false,
      autoSlider: true,
      intervalSlider: 5000
    };
  },
  computed: {
    homepage() {
      return this.$store.state.page.homepage;
    }
  },
  methods: {
    onSlideChangeStart(currentPage, el) {},
    onSlideChangeEnd(currentPage, el) {},
    ...mapActions("page", {
      getHomepage: "getHomepage"
    }),
    loadData() {
      fetchInitialData(this.$store, this.$route);
    },
    createLightbox() {
      var self = this;
      Vue.nextTick(() => {
        self.showLightbox = false;
        Vue.nextTick(() => {
          self.showLightbox = true;
        });
      });
    },
    add(addThis) {
      this.$refs.siema.append(addThis);
      this.siemaLoading = false;
    }
  },
  watch: {
    homepage: function(nhomepage) {
      var self = this;
      var style = document.getElementById("styleAMA");
      if (document.getElementById("styleAMA") === null) {
        style = document.createElement("style");
        style.setAttribute("id", "styleAMA");
      }
      style.innerHTML = nhomepage.style;
      document.body.appendChild(style);
      this.showSlider = true;
      document.addEventListener("click", function(e) {
        if (event.target.classList.contains("n2-ss-section-main-content")) {
          let parent = event.target;
          parent.querySelector("a").click();
        }
        return;
      });
      // var it9
    }
  },
  prefetch: fetchInitialData,
  mounted() {
    this.loadData();

    const element = document.getElementById("page");
    element.classList.add("addAnimation");
  },
  beforeCreate: function() {
    document.body.classList.remove("redBackground");
    document.body.classList.remove("invertedHeader");
  },
  beforeDestroy: function() {
    document.body.classList.remove("home");
  }
};
</script>

<style lang="scss">
.slider {
  width: 100vw;
  height: 100vh;
}
.slider-wrap > div {
  width: 100vw;
  height: 100vh;
}
.thisIsHome {
  position: relative;
  z-index: 5;
}
.n2-ss-slide-background,
.n2-ss-slide-2 {
  width: 100vw;
  min-height: 100vh;
}
.n2-ss-slide-background img {
  display: block;
  width: 100vw;
  min-height: 100vh;
  object-fit: cover;
}
.n2-ss-slide {
  position: relative;
}
.n2-ss-layers-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0 0% 5% 0;
}
.n2-ss-section-main-content {
  padding: 12px 60px !important;
  background: #ffffff;
  background: rgba(182, 30, 62, 0.5);
  h1,
  h2 {
    color: #fff;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 300;
    padding: 0;
    margin: 0;
  }
}
</style>
